var _defs, _path, _polygon, _polygon2, _polygon3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 239.39 187.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#032635;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-790,2223.59a87.74,87.74,0,0,1,36.38,47.16,88.18,88.18,0,0,1-56.81,111,91.9,91.9,0,0,1-12.09,2.9,88,88,0,0,0,74.59,9.63,88.17,88.17,0,0,0,56.82-111A88.1,88.1,0,0,0-790,2223.59Z",
    transform: "translate(926.22 -2222.29)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61 184.49 38.61 174.97 18.04 187.96 20.24 163.72 1.5 148.18 25.25 142.8 34.21 120.16 46.71 141.04 70.99 142.6 54.99 160.94 61 184.49"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "47.34 73.58 29.51 65.99 13.17 76.34 14.9 57.06 0 44.68 18.89 40.41 26.02 22.39 35.96 38.98 55.28 40.24 42.57 54.84 47.34 73.58"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "127.42 102.98 112.07 96.46 98.01 105.33 99.49 88.75 86.68 78.1 102.93 74.44 109.06 58.94 117.62 73.24 134.24 74.3 123.3 86.87 127.42 102.98"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.946bcf9e6aa9cf6dabcf0f7a232fb5b1.svg";
export { ForwardRef as ReactComponent };